// Check if we're on production domain
const isProduction = window.location.hostname === 'app.pathboxai.com';

// Use appropriate API URL based on hosting domain
export const baseUri = isProduction 
  ? process.env.REACT_APP_API_BASE_URI_PROD || ''
  : process.env.REACT_APP_API_BASE_URI_DEV || '';

export const basePath = '/api/v1';
export const baseURL = `${baseUri}${basePath}`;